// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type CoverageAnalysisSeverity = (typeof CoverageAnalysisSeverity)[keyof typeof CoverageAnalysisSeverity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoverageAnalysisSeverity = {
  ok: 'ok',
  minor: 'minor',
  critical: 'critical',
} as const;
